import { findSkuDetail } from "../../utils/findSkuDetail";
import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./rejectedsticker.css";
import Table from "react-bootstrap/Table";

const Rejectedsticker = () => {
  const [data2, setData] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);
  const [selectedTimestamp, setSelectedTimestamp] = useState(null);
  const [details, setDetails] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/CorrectBarcode`)
      .then((response) => {
        const latestDocuments = response.data.latestDocuments;
        if (Array.isArray(latestDocuments)) {
          setData(latestDocuments);
        } else {
          console.error("Unexpected data format:", response.data);
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
      });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      const filteredData = response.data.map((item) => ({
        sku: item.sku,
        title: item.title,
        Medium: item.Medium,
        edition: item.edition,
      }));
      setDetails(filteredData);
    });
  }, []);

  const handleTimestampClick = (timestamp) => {
    setSelectedTimestamp(timestamp);
    const selectedData = data2.find(
      (batch) => new Date(batch.timestamp).toLocaleString() === timestamp
    );
    if (selectedData) {
      const formattedData = selectedData.updates.map((update) => {
        const matchingDetail = findSkuDetail(details, update.keyValue);
        return {
          originalValue: update.originalValue,
          correctedValue: update.correctedValue,
          keyValue: update.keyValue,
          detail: matchingDetail || null,
        };
      });
      setBarcodeData(formattedData);
    } else {
      setBarcodeData([]);
    }
  };

  const selectedBatch = data2.find(
    (batch) => new Date(batch.timestamp).toLocaleString() === selectedTimestamp
  );

  return (
    <div className="rejectedsticker-container">
      <main className="rejectedsticker-workspace">
        <header className="rejectedsticker-header">
          <div>
            <span className="rejectedsticker-eyebrow">Sticker control / Quality review</span>
            <h1>Rejected sticker batches</h1>
            <p>Choose a batch to review its rejected sticker values and barcode keys.</p>
          </div>
          <span className="rejectedsticker-header-badge">
            <span aria-hidden="true" />
            {data2.length} {data2.length === 1 ? "batch" : "batches"} available
          </span>
        </header>

        <section className="rejectedsticker-overview" aria-label="Rejected sticker summary">
          <article className="rejectedsticker-stat-card">
            <span className="rejectedsticker-stat-mark" aria-hidden="true">01</span>
            <div>
              <span className="rejectedsticker-stat-label">Available batches</span>
              <strong>{data2.length}</strong>
              <small>Batch records ready for review</small>
            </div>
          </article>
          <article className="rejectedsticker-stat-card">
            <span className="rejectedsticker-stat-mark rejectedsticker-stat-mark--batch" aria-hidden="true">02</span>
            <div>
              <span className="rejectedsticker-stat-label">Selected batch</span>
              <strong className="rejectedsticker-stat-value">
                {selectedBatch ? selectedBatch.batchId : "—"}
              </strong>
              <small>{selectedTimestamp || "Select a batch below"}</small>
            </div>
          </article>
          <article className="rejectedsticker-stat-card">
            <span className="rejectedsticker-stat-mark rejectedsticker-stat-mark--count" aria-hidden="true">03</span>
            <div>
              <span className="rejectedsticker-stat-label">Rejected stickers</span>
              <strong>{selectedTimestamp ? barcodeData.length : "—"}</strong>
              <small>{selectedTimestamp ? "In the selected batch" : "Choose a batch to see its count"}</small>
            </div>
          </article>
        </section>

        <section className="rejectedsticker-panel" aria-label="Rejected sticker records">
          <div className="rejectedsticker-panel-header">
            <div>
              <span className="rejectedsticker-section-eyebrow">Batch review</span>
              <h2>Rejected barcode records</h2>
              <p>Compare the rejected sticker value with its associated key value.</p>
            </div>
            {selectedTimestamp && (
              <span className="rejectedsticker-record-count">
                {barcodeData.length} {barcodeData.length === 1 ? "RECORD" : "RECORDS"}
              </span>
            )}
          </div>

          <div className="rejectedsticker-selector">
            <label htmlFor="rejectedsticker-batch-select">Select batch ID and timestamp</label>
            <select
              id="rejectedsticker-batch-select"
              value={selectedTimestamp || ""}
              onChange={(e) => handleTimestampClick(e.target.value)}
            >
              <option value="">Choose a batch to review</option>
              {data2.map((batch) => (
                <option
                  key={batch.timestamp}
                  value={new Date(batch.timestamp).toLocaleString()}
                >
                  {"Batch ID: " + batch.batchId + " | " + new Date(batch.timestamp).toLocaleString()}
                </option>
              ))}
            </select>
          </div>

          <div className="rejectedsticker-table-wrap">
            {selectedTimestamp ? (
              <Table className="rejectedsticker-table">
                <thead>
                  <tr>
                    <th scope="col">Serial number</th>
                    <th scope="col">Rejected sticker value</th>
                    <th scope="col">Key value</th>
                  </tr>
                </thead>
                <tbody>
                  {barcodeData.length > 0 ? (
                    barcodeData.map(({ originalValue, keyValue }, index) => (
                      <tr key={index}>
                        <td data-label="Serial number">
                          <span className="rejectedsticker-serial">{index + 1}</span>
                        </td>
                        <td data-label="Rejected sticker value">
                          <span className="rejectedsticker-code">{originalValue}</span>
                        </td>
                        <td data-label="Key value">
                          <span className="rejectedsticker-code">{keyValue}</span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="rejectedsticker-empty-cell" colSpan={3}>
                        <div className="rejectedsticker-empty-state">
                          <span className="rejectedsticker-empty-mark" aria-hidden="true">✓</span>
                          <strong>No rejected stickers in this batch</strong>
                          <span>This batch does not contain any rejected barcode records.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            ) : (
              <div className="rejectedsticker-empty-state rejectedsticker-empty-state--initial">
                <span className="rejectedsticker-empty-mark" aria-hidden="true">01</span>
                <strong>Select a batch to begin</strong>
                <span>Choose a batch above to view its rejected sticker values and key values.</span>
              </div>
            )}
          </div>

          <footer className="rejectedsticker-panel-footer">
            {selectedTimestamp
              ? "Showing " + barcodeData.length + " rejected " +
                (barcodeData.length === 1 ? "sticker" : "stickers") +
                " for batch " + (selectedBatch?.batchId ?? "")
              : "Select a batch to display its rejected barcode records."}
          </footer>
        </section>
      </main>
    </div>
  );
};

export default Rejectedsticker;
